import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  makeStyles,
  Box,
} from '@material-ui/core'
import CloseIcon from '../../icons/generated/CloseIcon'

const useStyles = makeStyles(theme => ({
  contentRoot: {
    minWidth: 300,
    minHeight: 500,
    padding: '0 25px 25px',
  },
  iframe: {
    width: '100%',
    height: '80vh',
    border: 'none',
    transform: 'scale(1)',
    transformOrigin: 'top left',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '80vh',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1),
  },
}))

type ProductSheetPopupProps = {
  open: boolean
  onClose: () => void
  sheetUrl: string
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  showTitle?: boolean
}

export const ProductSheetPopup: React.FC<ProductSheetPopupProps> = ({
  open,
  onClose,
  sheetUrl,
  maxWidth = 'xs',
  showTitle = true,
}) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      {showTitle && (
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <span style={{ fontWeight: 700, fontSize: 20 }}>Energimærke</span>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      {!showTitle && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Box>
      )}
      <DialogContent className={classes.contentRoot}>
        {sheetUrl.endsWith('.png') ||
        sheetUrl.endsWith('.jpg') ||
        sheetUrl.endsWith('.jpeg') ? (
          <img src={sheetUrl} alt="Energimærkning" className={classes.image} />
        ) : (
          <iframe
            src={sheetUrl}
            className={classes.iframe}
            title="Energimærkning PDF"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
